import {
    GET_ALLOCATION_DETAILS,
    GET_ALLOCATION_DETAILS_SUCCESS,
    GET_ALLOCATION_DETAILS_FAILURE,
    RESET_ALLOCATION_DETAILS,
} from '../actions';

const initialState = {
    allocationDetails: null,
    allocationContext: null,
    loading: false,
    error: null,
};

const allocationDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ALLOCATION_DETAILS:
            return { ...state, loading: true, error: null, allocationContext: action.payload };
        case GET_ALLOCATION_DETAILS_SUCCESS:
            return { ...state, loading: false, allocationDetails: action.payload, error: null };
        case GET_ALLOCATION_DETAILS_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case RESET_ALLOCATION_DETAILS:
            return initialState;
        default:
            return state;
    }
};

export default allocationDetailsReducer;
